import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet?: any;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  const token = localStorage.getItem("access_token");
  if (token != null) {
    return outlet ? outlet : <Outlet />;
  } else {
    return <Navigate to={authenticationPath} replace />;
  }
}
